'use strict';
import request from '@/utils/request';
class OfficeService{
    static list(query){
        return request({
            url:'/company/getlistoffice',
            method:'get',
            params:query
        })
    }
    static dataoffice(query){
        return request({
            url:'/company/getofficedataforadministration',
            method:'get',
            params:query
        })
    }
    static create(data){
        return request({
            url:'/cart/store',
            method:'post',
            data
        });
    }
    static createOffice(data){
        return request({
            url:'company/createofficecompany',
            method:'post',
            data
        });
    }
    static updateOffice(data){
        return request({
            url:'company/editofficecompany',
            method:'put',
            data
        });
    }
}

export default OfficeService;
